import type { FaireProductEntity } from "../../entity_types/product";

export const p_f3c75z6vje: FaireProductEntity = {
  token: "p_f3c75z6vje",
  type: "product",
  name: "Dana Cami - Made with Organic Cotton (2S-2M-1L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/3261bf8cb891fd51c463ef30bebdc2c27e46cd17ad5cf655de9521f2291b23da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c4975e511b2d2371279182beb00746c0865f6e84c391aad79c597eb7a9a570d.jpeg",
    "https://cdn.faire.com/fastly/3ddb67c54c26b6ab19d40dda5b7da7dc9a445d298ef96c9ccfd947e2b496aa4a.jpeg",
    "https://cdn.faire.com/fastly/54c94681dde989c6e6e5dd982e55bc8a76719614e63951e1dcffc9c61b555dd8.jpeg",
    "https://cdn.faire.com/fastly/8e24b24bdcc0c9339579c825dcf7f786e0e04cf93320d503c0fdbb19e11511c8.jpeg",
    "https://cdn.faire.com/fastly/ec35328987d8263a4280552a7bc5d2e4964cdc3c61e627c49566e83b77a1c0be.jpeg",
    "https://cdn.faire.com/fastly/20723585fffa8a931ed7f270a48377a140f042d0a2e9a4412e870b75609d2627.jpeg",
    "https://cdn.faire.com/fastly/d6cdd84932c1738b291e7b924ab8467201cdf5a6b2f1457972930c57ca776ec6.jpeg",
    "https://cdn.faire.com/fastly/da06183cdbe808bc15dc4a3cec625662ff323d327435cc1295b21774a928f585.jpeg",
    "https://cdn.faire.com/fastly/6f15d2ad1afd0f7aa60e0b77e34008f39c337d566bb9c4615af3355391c23a31.jpeg",
    "https://cdn.faire.com/fastly/e0f2dfda1fbeb0deea6345cec6c1d8c7e107c2fd1ab08174f061d65cc034bf23.jpeg",
    "https://cdn.faire.com/fastly/eacc29d3d95587a76b8eb76c5febd6fc4596f1a70a0dbf9a2ee04abc3097f2ae.jpeg",
    "https://cdn.faire.com/fastly/6a895cde9e02fb5714e0f5f5b1c7bf850e3123485d3d9e573dde36eef92e1ebb.jpeg",
  ],
  priceDollars: 120,
  description:
    'Why We Made This?\n\nBase layering just got easier with the Dana Cami. This year-round wardrobe staple features a slim-fitting shape, complete with binding trim that sweeps the neckline and straps for a classic, secure look. A mid-cut, curved neckline offers just the right amount of coverage and the perfect length for both tucked and untucked styling. Made from 100% organic cotton, this lightweight, airy tank has a slight fade to give that vintage, lived-in feel you know and love.\n\nMade in Los Angeles, USA \n\nPlease note:\n\nThe dyeing and washing process gives each garment unique character. Please allow for slight color and fit variation for each garment. \n\nContents:\n\n100% Cotton\n\n\nCare Instructions:\n\nDue to the nature of pigment dye, loose pigments may remain on the surface of the garments.\n\n-Do not spot clean \n\n-Washing these garments only with like colors and in cold water\n\n-Hang Dry \n\nApproximate Measurements:\n\nLength: 20"(S), 20 1/2"(M), 21"(L) Chest : 15"(S), 16"(M), 17"(L)\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size Small\n\n\nMSRP: $49 USD \n\n',
  tags: [],
  msrpDollars: 240,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:03.432Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
